<div class="page-wrapper">
  <div class="login-container">

    <!-- Header -->
    <div class="login-header">
      <img src="/assets/healthpicks-operator/images/logo.svg" alt="Health Picks" class="logo-img" />
      <h1 class="screen-title">運用者画面</h1>
    </div>

    <!-- Card -->
    <div class="login-card">
      <h2 class="card-title">ログイン</h2>

      <!-- Login errors: Figma login_error (3653:7535) — red fields + helper under password only, no top banner -->

      <form (ngSubmit)="login()">
        <!-- Email -->
        <div class="field-group">
          <div class="field-label">
            <label for="email">メールアドレス</label>
          </div>
          <div class="field-input-stack">
            <input
              type="email"
              id="email"
              [(ngModel)]="email"
              name="email"
              placeholder="name@example.com"
              autocomplete="email"
              [class.input-error]="errorMessages.login.email || errorMessages.login.password"
              class="form-input"
            />
            <app-healthpicks-operator-field-error [message]="errorMessages.login.email"></app-healthpicks-operator-field-error>
          </div>
        </div>

        <!-- Password — Figma login_error: input + helper gap 4px under field -->
        <div class="field-group">
          <div class="field-label">
            <label for="password">パスワード</label>
          </div>
          <div class="field-input-stack">
            <!-- Figma 3653:7521: ● (U+25CF) via mirror; real value in transparent text input -->
            <div
              class="form-input form-input-password-wrap"
              [class.input-error]="errorMessages.login.email || errorMessages.login.password"
            >
              <app-healthpicks-operator-password-input
                [(ngModel)]="password"
                name="password"
                placeholder="●●●●●●●"
              ></app-healthpicks-operator-password-input>
            </div>
            <app-healthpicks-operator-field-error [message]="errorMessages.login.password"></app-healthpicks-operator-field-error>
          </div>
        </div>

        <!-- Remember email checkbox -->
        <div class="checkbox-row">
          <label class="checkbox-label" for="save-email">
            <span class="checkbox-icon-wrap">
              <input
                type="checkbox"
                id="save-email"
                name="saveEmail"
                [(ngModel)]="isSaveEmail"
                class="checkbox-input-hidden"
              />
              <img
                [src]="isSaveEmail
                  ? '/assets/healthpicks-operator/images/checkbox-checked.svg'
                  : '/assets/healthpicks-operator/images/checkbox-unchecked.svg'"
                alt=""
                class="checkbox-icon"
                width="24"
                height="24"
                aria-hidden="true"
              />
            </span>
            <span class="checkbox-text">メールアドレスを保存する</span>
          </label>
        </div>

        <!-- Submit -->
        <button
          type="submit"
          id="btn-login"
          class="btn-primary"
          [class.btn-disabled]="!email || !password"
          [disabled]="!email || !password"
        >
          ログイン
        </button>

        <!-- Forgot password -->
        <div class="forgot-pw-row">
          <span>パスワードをお忘れの方</span>
          <button type="button" class="forgot-pw-link" (click)="navigate('forgot-password')">パスワード再設定</button>
        </div>
      </form>
    </div>

  </div>
</div>
